import '../../../js/vendor/polyfills/polyfill-array-from.js';
import '../../../js/vendor/polyfills/polyfill-classlist.js';
import '../../../js/vendor/polyfills/polyfill-request-animation-frame.js';

import Component from '../../../js/core/component.js';

/**
 * SubNavigation Class
 */
class SubNavigation extends Component {

	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
        return
	}

	/**
	 * Initialize SubNavigation
	 */
	_init () {
        var toggleButtons = document.querySelectorAll('.c-sub-navigation__hide-toggle-button');

        toggleButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                var subNavigationContent = this.nextElementSibling;
                var subNavigationToggleArrow = this.querySelector('.c-sub-navigation__hide-toggle-arrow');
                if (subNavigationContent.style.display !== 'block') {
                    subNavigationContent.style.display = 'block';
                    subNavigationToggleArrow.style.transform = 'rotate(180deg)';
                } else {
                    subNavigationToggleArrow.style.transform = 'rotate(0deg)';
                    subNavigationContent.style.display = 'none';
                }
            });
        });
    }
}
document.addEventListener('newcontent', (e) => {
	const subNav = e.target.querySelector('.c-sub-navigation');
	if(subNav) {
		subNav.subNavigation = new SubNavigation({
			element: subNav
		});
	}
});


export default SubNavigation;


// WEBPACK FOOTER //
// ./components/navigation/sub-navigation/c-sub-navigation.js